//
// LoadingScreen
//
// Show this when we're loading the application from the server

import { observer } from 'mobx-react-lite'

import { LoadingWorkspace } from '../workspaces'
import { AppScreen } from './AppScreen'

export const LoadingScreen = observer(function LoadingScreen() {
    return (
        <AppScreen>
            <LoadingWorkspace />
        </AppScreen>
    )
})
